import { Type } from 'class-transformer';
import dayjs from 'dayjs';
import { Event } from './event';
import { Model } from './model';
import { TransformStringToDayJS } from './utils';

export enum FunctionRunStatus {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SCHEDULED = 'scheduled',
  QUEUED = 'queued',
  SKIPPED = 'skipped',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RUNNING = 'running',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PENDING_RETRY = 'pending_retry',
  COMPLETE = 'complete',
}

export class FunctionRun extends Model {
  id: string;

  attempts: number;

  @TransformStringToDayJS()
  completed_at: dayjs.Dayjs | null;

  event_id: string;

  @Type(() => Event)
  event: Event;

  @TransformStringToDayJS()
  started_at: dayjs.Dayjs | null;

  status: FunctionRunStatus;
}
